import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from '../../BuiltinInstanceMemberCall';
export class SmartContractDestroy extends BuiltinInstanceMemberCall {
    canCall(_sb, _func, node) {
        return tsUtils.argumented.getArguments(node).length === 0;
    }
    emitCall(sb, _func, node, optionsIn, visited) {
        if (visited) {
            sb.emitOp(node, 'DROP');
        }
        sb.emitSysCall(node, 'Neo.Contract.Destroy');
        if (optionsIn.pushValue) {
            sb.emitHelper(node, optionsIn, sb.helpers.wrapUndefined);
        }
    }
}

//# sourceMappingURL=destroy.js.map
